var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "list"
  }, [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      size: "mini",
      data: _vm.dataList,
      border: "",
      stripe: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "date",
      label: "作业编号"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "被审客户名称"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "作业名称",
      prop: "address"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "发函地址",
      prop: "address"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "收件人",
      prop: "address"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "收件人职位",
      prop: "address"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "联系电话",
      prop: "address"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "备用电话",
      prop: "address"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "核查方式",
      prop: "address"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "地址距离",
      prop: "address"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "核查过程记录",
      prop: "address"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "地址核查结论",
      prop: "address"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "核查人姓名",
      prop: "address"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "核查人日期",
      prop: "address"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return undefined;
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };